import { render, staticRenderFns } from "./search-header.vue?vue&type=template&id=2a69b08d"
import script from "./search-header.vue?vue&type=script&lang=ts"
export * from "./search-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports